/**
 * Schedule visibility for announcement bar & hero banner items.
 * Format: YYYY-MM-DD HH:MM (same as flash sale countdown)
 */
(function () {
  'use strict';

  if (window.__bohopanaScheduleVisibilityLoaded) return;
  window.__bohopanaScheduleVisibilityLoaded = true;

  function parseScheduleDate(value) {
    if (!value) return NaN;
    var normalized = String(value).trim();
    var dateMatch = normalized.match(/^(\d{4})-(\d{2})-(\d{2})[.\sT](\d{1,2}):(\d{2})$/);
    if (dateMatch) {
      return new Date(
        parseInt(dateMatch[1], 10),
        parseInt(dateMatch[2], 10) - 1,
        parseInt(dateMatch[3], 10),
        parseInt(dateMatch[4], 10),
        parseInt(dateMatch[5], 10),
        0
      ).getTime();
    }
    var parsed = new Date(normalized).getTime();
    return parsed;
  }

  function isInSchedule(startValue, endValue) {
    var now = Date.now();
    var startTime = parseScheduleDate(startValue);
    var endTime = parseScheduleDate(endValue);
    if (!isNaN(startTime) && now < startTime) return false;
    if (!isNaN(endTime) && now >= endTime) return false;
    return true;
  }

  function refreshAnnouncement(sectionEl) {
    var track = sectionEl.querySelector('.announcement-carousel__track');
    if (!track) return;

    var items = Array.prototype.slice.call(
      sectionEl.querySelectorAll('[data-schedule-item]')
    );
    var visibleCount = 0;

    items.forEach(function (item) {
      var active = isInSchedule(item.getAttribute('data-schedule-start'), item.getAttribute('data-schedule-end'));
      item.hidden = !active;
      item.style.display = active ? '' : 'none';
      if (active) visibleCount += 1;
    });

    track.style.setProperty('--ann-item-count', String(Math.max(visibleCount, 1)));
    track.setAttribute('data-ann-count', String(visibleCount));

    if (visibleCount === 0) {
      sectionEl.hidden = true;
      sectionEl.style.display = 'none';
      var wrapper = sectionEl.closest('.shopify-section, .announcement-bar-wrapper');
      if (wrapper) {
        wrapper.hidden = true;
        wrapper.style.display = 'none';
      }
    } else {
      sectionEl.hidden = false;
      sectionEl.style.display = '';
      var wrap = sectionEl.closest('.shopify-section, .announcement-bar-wrapper');
      if (wrap) {
        wrap.hidden = false;
        wrap.style.display = '';
      }
    }
  }

  function refreshHero(sectionEl) {
    var slider = sectionEl.matches('.hero-slider')
      ? sectionEl
      : sectionEl.querySelector('.hero-slider');
    if (!slider) return;

    var track = slider.querySelector('.hero-slider__track');
    if (!track) return;

    track.querySelectorAll('.hero-slider__slide--clone').forEach(function (clone) {
      clone.remove();
    });

    var slides = Array.prototype.slice.call(
      track.querySelectorAll('.hero-slider__slide[data-schedule-item]')
    );
    var visibleCount = 0;
    var visibilityChanged = false;

    slides.forEach(function (slide) {
      var active = isInSchedule(
        slide.getAttribute('data-schedule-start'),
        slide.getAttribute('data-schedule-end')
      );
      var wasHidden = slide.hidden || slide.style.display === 'none';
      if (wasHidden === active) visibilityChanged = true;
      slide.hidden = !active;
      slide.style.display = active ? '' : 'none';
      if (active) visibleCount += 1;
    });

    var arrows = slider.querySelectorAll('.hero-slider__arrow');
    var progress = slider.querySelector('.hero-slider__progress-bar');
    var showControls = visibleCount > 1;
    arrows.forEach(function (btn) {
      btn.hidden = !showControls;
      btn.style.display = showControls ? '' : 'none';
    });
    if (progress) {
      progress.hidden = !showControls;
      progress.style.display = showControls ? '' : 'none';
    }

    var wrapper = slider.closest('.shopify-section, .hero-banner-wrapper');

    if (visibleCount === 0) {
      slider.hidden = true;
      slider.style.display = 'none';
      if (wrapper) {
        wrapper.hidden = true;
        wrapper.style.display = 'none';
      }
      return;
    }

    slider.hidden = false;
    slider.style.display = '';
    if (wrapper) {
      wrapper.hidden = false;
      wrapper.style.display = '';
    }

    if (!visibilityChanged && slider.dataset.heroInitialized === 'true') return;

    // Replace node to drop old listeners, then re-init with active slides only
    var parent = slider.parentNode;
    if (!parent) return;

    var inactive = [];
    slides.forEach(function (slide) {
      if (slide.hidden) {
        inactive.push(slide);
        slide.remove();
      }
    });

    var fresh = slider.cloneNode(true);
    fresh.dataset.heroInitialized = 'false';
    var freshTrack = fresh.querySelector('.hero-slider__track');
    if (freshTrack) {
      freshTrack.style.transition = 'none';
      freshTrack.style.transform = 'translateX(0%)';
      freshTrack.querySelectorAll('.hero-slider__slide--clone').forEach(function (clone) {
        clone.remove();
      });
    }
    parent.replaceChild(fresh, slider);

    if (typeof window.__bohopanaInitHeroSlider === 'function') {
      window.__bohopanaInitHeroSlider(fresh);
    }

    var liveTrack = fresh.querySelector('.hero-slider__track');
    if (liveTrack) {
      inactive.forEach(function (slide) {
        liveTrack.appendChild(slide);
      });
    }
  }

  function refreshAll() {
    document.querySelectorAll('[data-schedule-section="announcement"]').forEach(refreshAnnouncement);
    document.querySelectorAll('[data-schedule-section="hero"]').forEach(refreshHero);
  }

  window.BohopanaScheduleVisibility = {
    refresh: refreshAll,
    isInSchedule: isInSchedule,
    parseScheduleDate: parseScheduleDate,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }

  // Auto hide/show when schedule windows change (no full reload)
  setInterval(refreshAll, 15000);
})();
